import Chart from 'chart.js/auto';
const chartjs = require('../../../../../../components/chart/chartjs')
const { changeSVG } = require('../../../../../../js-handler/graphic')

let barSimpleChart = null;

export function createChart(historyData) {
	const chartContainer = document.querySelector('.card-chart');
    if (!chartContainer) return;

    chartContainer.innerHTML = '<canvas class="chartjs" id="itemQuickViewChart"></canvas>';
    const canvas = document.getElementById('itemQuickViewChart');

	const existingChart = Chart.getChart(canvas);

	if (existingChart) {
		existingChart.destroy();
	}

	const labelsX = historyData.map(p => {
		const fecha = new Date(p.month + 'T00:00:00');
		return fecha.toLocaleString('default', { month: 'short' });
	});

	const metricsToGraph = [
		{ key: 'roi', label: 'ROI (%)', color: 'green' },
		{ key: 'speed', label: 'SPEED', color: 'blue' },
		{ key: 'friction', label: 'FRICTION', color: 'red' }
	];

	const chartData = metricsToGraph.map((m, index) => {
		return {
			label: m.label,
			color: m.color,
			tension: 0.4,
			borderWidth: 2,
			fill: false,
			value: historyData.map((periodo, i) => ({
				x: labelsX[i],
				y: parseFloat(periodo[m.key]) || 0
			}))
		};
	});

	barSimpleChart = chartjs.start({
		elem: 'line',
		act: 'createMultiple',
		targetChart: { html: canvas },
		data: chartData,
		options: {
			reponsive: true,
			maintainAspectRatio: false,
			aspectRatio: 10 / 3,
			legend: true,
			plugins: {
				tooltip: { enabled: true }
			},
			scales: {
				y: {
					beginAtZero: true,
					grid: { color: 'rgba(0,0,0,0.05)' }
				}
			}
		}
	});
}
